import { render, staticRenderFns } from "./draws.vue?vue&type=template&id=2f2a74ee&scoped=true&"
import script from "./draws.vue?vue&type=script&lang=js&"
export * from "./draws.vue?vue&type=script&lang=js&"
import style0 from "./draws.vue?vue&type=style&index=0&id=2f2a74ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2a74ee",
  null
  
)

export default component.exports